import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { loginGuard } from './shared/guards/login.guard';
import { paineisAnaliticosVisualizacoesGuard } from './shared/guards/paineis-analiticos-visualizacoes.guard';

export const routes: Routes = [
    {
        path: 'login',
        canActivate: [loginGuard],
        loadComponent: () => import('./views/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: '',
        canActivate: [authGuard],
        children: [
            {
                path: 'home',
                loadComponent: () => import('./views/home/home.component').then((m) => m.HomeComponent),
            },
            {
                path: 'sobre',
                loadComponent: () => import('./views/sobre/sobre.component').then((m) => m.SobreComponent),
            },
            {
                path: 'acessibilidade',
                loadComponent: () =>
                    import('./views/acessibilidade/acessibilidade.component').then((m) => m.AcessibilidadeComponent),
            },
            {
                path: 'mapa-site',
                loadComponent: () => import('./views/mapa-site/mapa-site.component').then((m) => m.MapaSiteComponent),
            },
            {
                path: 'painel-indicadores',
                loadComponent: () =>
                    import('./views/painel-indicadores/painel-indicadores.component').then(
                        (m) => m.PainelIndicadoresComponent
                    ),
                children: [
                    {
                        path: 'dimensoes',
                        loadComponent: () =>
                            import('./views/painel-indicadores/dimensoes/dimensoes.component').then(
                                (m) => m.DimensoesComponent
                            ),
                    },
                    {
                        path: 'contexto',
                        loadComponent: () =>
                            import('./views/painel-indicadores/contexto/contexto.component').then(
                                (m) => m.ContextoComponent
                            ),
                    },
                    {
                        path: '',
                        redirectTo: 'dimensoes',
                        pathMatch: 'full',
                    },
                ],
            },
            {
                path: 'paineis-analiticos',
                loadComponent: () =>
                    import('./views/paineis-analiticos/paineis-analiticos.component').then(
                        (m) => m.PaineisAnaliticosComponent
                    ),
                children: [
                    {
                        path: 'acesso',
                        loadComponent: () =>
                            import('./views/paineis-analiticos/acesso/acesso-paineis-analiticos.component').then(
                                (m) => m.AcessoPaineisAnaliticosComponent
                            ),
                    },
                    {
                        path: 'dispersao',
                        canActivate: [paineisAnaliticosVisualizacoesGuard],
                        loadComponent: () =>
                            import('./views/paineis-analiticos/dispersao/dispersao.component').then(
                                (m) => m.DispersaoComponent
                            ),
                    },
                    {
                        path: 'mapas',
                        canActivate: [paineisAnaliticosVisualizacoesGuard],
                        loadComponent: () =>
                            import('./views/paineis-analiticos/mapas/mapas.component').then((m) => m.MapasComponent),
                    },
                    {
                        path: '',
                        redirectTo: 'acesso',
                        pathMatch: 'full',
                    },
                ],
            },
            {
                path: 'bases-de-dados',
                loadComponent: () =>
                    import('./views/bases-de-dados/bases-de-dados.component').then((m) => m.BasesDeDadosComponent),
            },
            {
                path: 'conteudo1',
                loadComponent: () => import('./views/conteudo1/conteudo1.component').then((m) => m.Conteudo1Component),
            },
            {
                path: 'menu2',
                loadComponent: () => import('./views/menu2/menu2.component').then((m) => m.Menu2Component),
            },
            {
                path: 'rodape3',
                loadComponent: () => import('./views/rodape3/rodape3.component').then((m) => m.Rodape3Component),
            },
            {
                path: '**',
                redirectTo: 'home',
            },
        ],
    },
    { path: '**', redirectTo: '/home', pathMatch: 'full' },
];
